<script setup>
const props = defineProps({
  required: {
    type: Boolean,
    default: false
  },
})
</script>

<template>
  <label class="text-sm flex lg:items-end gap-1 flex-col lg:flex-row leading-none mb-2">
    <strong class="font-bold text-base md:text-lg leading-none md:leading-none">
      <slot />
    </strong>
    <span v-if="required">(required)</span>
  </label>
</template>
